import React, { useState } from "react"
import { Grid, Button, withStyles } from "@material-ui/core"
import Module from "./Module"
import { CourseDetails } from "../../../../shared/constants"
import ShowComingSoon from "./ShowComingSoon"

const Syllabus = ({ data, onEnrollClick, enrollUrl }) => {
  if (data.length === 0) {
    return <ShowComingSoon/>
  }
  return <ShowSyllabus data={data} onEnrollClick={onEnrollClick} enrollUrl={enrollUrl}/>
}

const ShowSyllabus = ({ data, onEnrollClick, enrollUrl }) => {
  const [showMore, setShowMore] = useState(false)
  const toggleShowMore = () => setShowMore(!showMore)
  const modules = showMore
    ? data
    : data.slice(0, CourseDetails.defaultShowModules)
  const showLabel = showMore ? "SEE LESS" : "SEE MORE"

  return (
    <Grid container spacing={3}>
      {modules.map((moduleData, i) => (
        <Grid item xs={12} key={i}>
          <Module data={moduleData} number={i + 1}/>
        </Grid>
      ))}
      <Grid item xs={12}>
        <CallToActions
          showMoreLabel={showLabel}
          onShowMoreClick={toggleShowMore}
          onEnrollClick={onEnrollClick}
          enrollUrl={enrollUrl}
        />
      </Grid>
    </Grid>
  )
}

const styles = theme => ({})

const CallToActions = ({
                         classes,
                         showMoreLabel,
                         onShowMoreClick,
                         onEnrollClick,
                         enrollUrl,
                       }) => (
  <Grid container justify={"center"} spacing={3}>
    <Grid item>
      <Button aria-label={showMoreLabel} color={"primary"} variant={"outlined"} onClick={onShowMoreClick}>
        {showMoreLabel}
      </Button>
    </Grid>
    <Grid item>
      <Button aria-label="Enroll Now" color={"primary"} variant={"contained"} onClick={() => onEnrollClick(enrollUrl)}>
        Enroll Now
      </Button>
    </Grid>
  </Grid>
)

export default withStyles(styles)(Syllabus)
